import { render, staticRenderFns } from "./TransferRequest.html?vue&type=template&id=9cffdcdc&"
import script from "./TransferRequest.js?vue&type=script&lang=js&"
export * from "./TransferRequest.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports